import PublicationsPage from './PublicationsPage';
export default PublicationsPage;
